// export const Urls="https://dni.tactionsoft.com/api/user/";
 export const Urls1="https://api.drugnutritioninteractions.com/api/";
// export const Urls1="https://dni.tactcon.in/api/"; 
// export const Urls1="http://localhost:5000/"; gi